/*
Reveal a "Read more" link on feed text cards only when their content is clamped.

Text / newsletter cards render the full post content (partials/post-card.hbs)
capped to --teaser-lines by CSS (components/post-card.css). The fade + Read-more
are shown BY DEFAULT (fail-safe); this flags the cards whose content actually
FITS the cap with `.content-fits`, which removes the clamp/fade/link.

Why fail-safe: whether a teaser overflows can depend on IMAGES inside it, whose
height is 0 until they load — so a "does it overflow?" check can race. But "does
it fit?" for a short text-only post is immediate and reliable. So we default to
faded and only strip it off the ones that provably fit. We still re-check on
media load, web-fonts ready, window load and resize, and watch the feed for
infinite-scroll cards — mainly so a genuinely-short post with a (small) image
still un-fades once measured.
*/

const SELECTOR = '.kryo-post-content[data-readmore]';

// Content "fits" when its full height doesn't exceed the (capped) visible height.
// Remove the flag first so the max-height cap is back in effect while measuring.
function check(el) {
    el.classList.remove('content-fits');
    if (el.scrollHeight - el.clientHeight <= 1) {
        el.classList.add('content-fits');
    }
}

function checkAll() {
    document.querySelectorAll(SELECTOR).forEach(check);
}

// Re-check once any not-yet-loaded media inside a teaser settles. Guarded so a
// given element is only wired once, even though watchMedia runs repeatedly.
function watchMedia(scope) {
    scope.querySelectorAll(SELECTOR + ' :is(img, iframe, video)').forEach(function (m) {
        if (m.dataset.rmWatched) { return; }
        m.dataset.rmWatched = '1';
        if (m.complete) { return; }
        m.addEventListener('load', checkAll);
        m.addEventListener('loadedmetadata', checkAll);
    });
}

export default function readMore() {
    if (!document.querySelector(SELECTOR)) { return; }

    checkAll();
    watchMedia(document);

    // Font swap changes text metrics.
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkAll);
    }

    // Safety net: fires after every image on the initial page has loaded, catching
    // any that raced the load-listener above.
    window.addEventListener('load', checkAll);

    // Re-check on resize (card width changes wrapping), debounced.
    let raf = 0;
    window.addEventListener('resize', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(checkAll);
    });

    // Infinite scroll appends new cards — re-check AND wire up their media.
    // Observe childList only (not attributes) so our own class toggles don't loop.
    document.querySelectorAll('.gh-postfeed').forEach(function (feed) {
        new MutationObserver(function (mutations) {
            if (mutations.some(function (m) { return m.addedNodes.length; })) {
                checkAll();
                watchMedia(feed);
            }
        }).observe(feed, { childList: true, subtree: true });
    });
}
